import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './context';
import { baseUrl } from './delcare';
import UiSpinner from './ui_spinner';
import BrandFragment from './brand_fragment';

const BrandPage = ({ isAdmin = false }) => {
    const navigate = useNavigate();

    const {
        neonUser, getBrands, brandList,
        offCanvas, setPopupSidebarType, showCanvas,
        setSideBarTitle, setEditBrandId, toggleCanvas,
        hh, ww,
        getAgencyClients,
        marketplaceList,
        adsProfileIdsLoaded,
    } = useContext(AppContext);

    const [displayList, setDisplayList] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const [toggle, setToggle] = useState(true);
    const [sortMode, setSortMode] = useState(1);
    const [agencyLoaded, setAgencyLoaded] = useState(false)

    const sortModeHandler = () => {
        const next = sortMode >= 2 ? 1 : sortMode + 1;
        const sorted = [...displayList].sort((a, b) => {
            const cmp = a.brand.toLowerCase().localeCompare(b.brand.toLowerCase());
            return next === 1 ? cmp : -cmp;
        });
        setSortMode(next);
        setDisplayList(sorted);
    };

    const filterList = () => {
        const list = brandList.filter(x =>
            x.brand.toLowerCase().includes(search.toLowerCase())
        );
        setDisplayList(list);
    };

    const showCanvasHandler = (title, type, id) => {
        setSideBarTitle(title);
        setPopupSidebarType(type);
        if (id) setEditBrandId(id);
        offCanvas.show();
    };

    useEffect(() => { filterList(); }, [search]);
    useEffect(() => { setDisplayList([...brandList]); }, [brandList]);

    useEffect(() => {
        if (!isAdmin && offCanvas) toggleCanvas();
    }, [showCanvas]);

    useEffect(() => {
        if (neonUser?.user_id && marketplaceList.length > 0) {
            (async () => {
                await getAgencyClients()
                setAgencyLoaded(true)
            })()
        }
    }, [neonUser, marketplaceList]);

    useEffect(() => {
        if (agencyLoaded) {
            (async () => {
                const result = await getBrands()
                if (result === false) {
                    setLoading(false)
                    return
                }
                setLoading(false)
            })()
        }
    }, [agencyLoaded && adsProfileIdsLoaded]);

    if (loading) return (
        <div className="d-flex justify-content-center" style={{ height: hh - 80 }}>
            <UiSpinner />
        </div>
    );

    return (
        <BrandFragment
            search={search}
            setSearch={setSearch}
            toggle={toggle}
            setToggle={setToggle}
            sortMode={sortMode}
            displayList={displayList}
            showCanvasHandler={showCanvasHandler}
            sortModeHandler={sortModeHandler}
            navigate={navigate}
            ww={ww}
            loading={loading}
            baseUrl={baseUrl}
        />
    );
};

export default BrandPage;